import React from "react";
import {connect} from "react-redux";
import MyTheme from "../../Theme/Theme";
import {
    Alert,
    Animated, Image,
    Platform,
    SafeAreaView,
    ScrollView,
    StyleSheet,
    Text,
    TouchableOpacity,
    View
} from "react-native";
import LogoComplet, {BOLogoComplet} from "../Picto/LogoComplet";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

import {
  getSwRegistration,
  listenForActivatingServiceWorker,
  listenForWaitingServiceWorker
} from "../../sw/sw_registration";
import { sw_api } from "../../sw/helpers";
import { preloadSw } from "../../sw/setup";


/*
RATIONAL FOR DYNAMIC CACHING
When should we dot it?

1. On first install : large, -> better response after
   type: foreground
2. On each update : large ?
   type: foreground
3. from time to time, to make sure we are updated: after NIP expiration (and if it didn't trigger an update)
   type: background

ALTERNATIVE:

2. update: foreground
else: NIP => go

---

When going back online, don't update the cache (too busy?)
But update user/me to check if we are still logged in (else redirect)

When NIP signing: update the cache in background

--
Problem w/ cache:
- we want to block if we are loading
- we dont want to block response when user is navigating

--

Scenario to check:
- brand new install: check SW is working smoothly
- update: NIP onExpire(): check SW is properly updating
- offline/online: check we are properly redirected if login expired
- navigation: navigate everywhere check we are ok

--

Special behaviour:
Dynamic fetching for api w/ dependencies: pois/user/bookmark
Everytime those API returning lists are fetched, we check for cache update looking at their update_at timestamp
That way, we have a smart cache without massive download


Posts won't be loaded fully unless you navigate to them directly
When offline, they will be returned without comments if not found
*/

class UpdateScreen extends React.Component{

    constructor(props) {
        super(props);

        let type = "unset";
        const sw = getSwRegistration()

        // last one win
        if (sw) {
          if (sw.active) { type = "activated"; }
          if (sw.waiting) { type = "waiting"; }
          if (sw.installing) { type = "installing"; }
        }

        this.state = { type };

        this.onWaiting = this.onWaiting.bind(this);
        this.onActivating = this.onActivating.bind(this);
        this.triggerActivate = this.triggerActivate.bind(this);
    }

    setFooter(){
        this.props.navigation.setOptions({
            tabBarVisible:false
        });
    }

    componentDidMount() {
      this.setFooter();

      const sw = getSwRegistration()
      // we wont unregister listener: it will end w/ a reload
      listenForWaitingServiceWorker(sw, this.onWaiting);
      listenForActivatingServiceWorker(sw, this.onActivating);
    }

    onWaiting() {
      const sw = getSwRegistration();

      this.setState({ type: "waiting" });

      // auto activate
      setTimeout(this.triggerActivate, 1000);
    }

    triggerActivate() {
      // skipWaiting, move to activate
      sw_api.skipWaiting();
    }

    onActivating() {
      this.setState({ type: "caching_dynamic" });

      Promise.all(preloadSw()).then(() => {
        this.setState({ type: "activated" });
        // auto reload
        setTimeout(this.triggerReload, 1000)
      })
    }

    triggerReload() {
      window.location.reload();
    }


    render() {
        const style = StyleSheet.create({
            droidSafeArea: {
                flex: 1,
                paddingTop: Platform.OS === 'android' ? 35 : 0,
                backgroundColor: this.props.theme.colors.primary.White.value
            },
            logo :{
                width:80,
                minHeight:100
            },
            logoContainer : {
                width:"100%",
                justifyContent:"center",
                alignItems:"center",
                flexDirection:"row",
                gap: 10,
                flex: 3
            },
            titleContainer : {
                marginVertical:10,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            textTitle :{
                textAlign:"center",
                color : this.props.theme.colors.tertiary.black1.value,
                // fontFamily : this.props.theme.fonts.text,
                fontFamily: this.props.theme.fonts.title,
                fontWeight : "700",
                padding: 20,
                fontSize: 15,
            },
            textInfo: {
              color : this.props.theme.colors.primary.blue1.value,
            },
            inputContainer : {
                display: "flex",
                justifyContent:"center",
                alignItems: "center"
            },
            button: {
              marginTop: 20,
              borderRadius: 10,
              borderWidth : 1,
              borderColor : this.props.theme.colors.tertiary.black10.value,
              backgroundColor: this.props.theme.colors.primary.blue1.value,
              justifyContent:"center",
            },
            buttonText: {
              color: this.props.theme.colors.primary.White.value,
              paddingVertical : 15,
              paddingHorizontal: 8,
            }
        });

        const {t} = this.props;
        const {type} = this.state;

        const d = {
          unset: () => {
            return {
              msg: t("Unknown state"),
              view: <TouchableOpacity style={style.button}
                                      onPress={() => {window.location.reload();}}>
                <Text style={style.buttonText}>{ t("Reload application") }</Text>
              </TouchableOpacity>
            }
          },
          installing: () => {
            return {
              msg: t("Application installing... please wait"),
            }
          },
          waiting: () => {
            return {
              msg: t("Application installed"),
              view: <TouchableOpacity style={style.button} onPress={this.triggerActivate}>
                <Text style={style.buttonText}>{ t("Activate application and cache") }</Text>
              </TouchableOpacity>
            }
          },
          caching_dynamic: () => {
            return {
              msg: t("Finishing caching setup... please wait"),
            }
          },
          activated: () => {
            return {
              msg: t("Application successfully activated"),
              view: <TouchableOpacity style={style.button} onPress={this.triggerReload}>
                <Text style={style.buttonText}>{ t("Reload application") }</Text>
              </TouchableOpacity>
            }
          },
        };

        const {msg, view} = d[type] && d[type]();

        return (
            <SafeAreaView style={style.droidSafeArea}>
                <TouchableOpacity onPress={this.triggerReload}>
                  <View style={style.logoContainer}>
                      <LogoComplet style={style.logo}/>
                      <BOLogoComplet style={style.logo} />
                  </View>
                </TouchableOpacity>

                <View style={style.titleContainer}>
                    <Text style={style.textTitle}>
                      {t('Application Update found')}
                    </Text>
                </View>

                <View style={style.inputContainer}>
                  <Text style={style.textInfo}>{msg}</Text>
                  { view }
                </View>
            </SafeAreaView>
        );
    }
}


const mapStateToProps = (state) => {
    return {
      isDark: state.changeTheme.isDark, theme: state.changeTheme.theme,
      NIP : state.AuthReducer.NIP, auth: state.AuthReducer
    };
}

export default compose(withTranslation(),connect(mapStateToProps))(UpdateScreen);
